import { supabase } from '../integrations/supabase/client';

export const logActivity = async (
  action: 'created' | 'updated' | 'deleted' | 'logged_in' | 'converted',
  tableName: string,
  recordId?: string,
  oldValues?: Record<string, any>,
  newValues?: Record<string, any>
) => {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    
    if (!user) return;

    const { error } = await supabase
      .from('activity_logs')
      .insert({
        user_id: user.id,
        action,
        table_name: tableName,
        record_id: recordId,
        old_values: oldValues,
        new_values: newValues,
        ip_address: null, // Could be implemented with a service
        user_agent: navigator.userAgent
      });

    if (error) throw error;
  } catch (error) {
    console.error('Error logging activity:', error);
  }
};

export const getActivityDescription = (log: any) => {
  const { action, table_name, new_values } = log;
  
  const tableNames: Record<string, string> = {
    leads: 'Lead',
    clients: 'Cliente',
    workshops: 'Workshop',
    resources: 'Recurso',
    automations: 'Automatización'
  };

  const actions: Record<string, string> = {
    created: 'creado',
    updated: 'actualizado',
    deleted: 'eliminado',
    logged_in: 'inició sesión',
    converted: 'convertido a cliente'
  };

  const tableName = tableNames[table_name] || table_name;
  const actionText = actions[action] || action;

  if (action === 'created' && new_values?.name) {
    return `${tableName} "${new_values.name}" ${actionText}`;
  }
  
  if (action === 'updated' && new_values?.name) {
    return `${tableName} "${new_values.name}" actualizado`;
  }

  if (action === 'converted' && new_values?.name) {
    return `Lead "${new_values.name}" ${actionText}`;
  }

  return `${tableName} ${actionText}`;
};
